module.exports = __webpack_public_path__ + "static/media/WK.69bfe0a4.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/images/WK.PNG
// module id = 1544
// module chunks = 1